var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.354.172A8.008 8.008 0 0 0 1.529 3.3 7.994 7.994 0 0 0 2.67 13.964a8.012 8.012 0 0 0 13.046-3.8l-1.926-.542a6 6 0 0 1-1.734 2.81A6.01 6.01 0 0 1 2.034 8.639a5.996 5.996 0 0 1 1.113-4.164 6.008 6.008 0 0 1 7.88-1.662c.497.288.946.644 1.335 1.053l-2.59 2.592 6.164-.075L16 .226l-2.224 2.226A8.014 8.014 0 0 0 6.354.172z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefresh);
export default __webpack_public_path__ + "static/media/ic-refresh.d8ed4792839b3b6edfce669b413ed43f.svg";
export { ForwardRef as ReactComponent };